import { api } from "./api";

// Client-side memoization so we don't re-hit the API for the same string.
const _cache = new Map();

function _hasCJK(text) {
  if (!text) return false;
  for (let i = 0; i < text.length; i++) {
    const c = text.charCodeAt(i);
    if (c >= 0x4e00 && c <= 0x9fff) return true;
  }
  return false;
}

/** Detect the language of a string ("en" or "zh"). */
export function detectLang(text) {
  return _hasCJK(text) ? "zh" : "en";
}

/**
 * Translate `text` into `target` ("en" | "zh"). Memoized per-tab.
 * Returns { translated_text, source_lang, target_lang, cached }.
 * If source == target, returns { unchanged: true, translated_text: text }.
 */
export async function translateText(text, target = "en") {
  const clean = (text || "").trim();
  if (!clean) return { translated_text: "", source_lang: target, target_lang: target, unchanged: true };
  if (detectLang(clean) === target) {
    return { translated_text: clean, source_lang: target, target_lang: target, unchanged: true };
  }
  const key = `${target}::${clean}`;
  if (_cache.has(key)) return _cache.get(key);
  const { data } = await api.post("/ai/translate", { text: clean, target_lang: target });
  _cache.set(key, data);
  return data;
}

export const LANG_LABEL = { en: "English", zh: "中文" };
export const LANG_FLAG = { en: "EN", zh: "中" };
